var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSchedule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M56.83 29.92v-7.97c0-3.46-2.8-6.25-6.25-6.25h-2.91m-32.6 0h-2.93a6.25 6.25 0 00-6.25 6.25v31.47c0 3.46 2.8 6.26 6.25 6.26H28.4m5.92-43.98H28.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M20.03 33.67a2 2 0 00-2-2h-1.96a2 2 0 00-2 2v1.96a2 2 0 002 2h1.96a2 2 0 002-2v-1.96zm.35 12.72a2 2 0 00-2-2h-1.96a2 2 0 00-2 2v1.96a2 2 0 002 2h1.96a2 2 0 002-2v-1.96zm13.96-12.72a2 2 0 00-2-2h-1.96a2 2 0 00-2 2v1.96a2 2 0 002 2h1.96a2 2 0 002-2v-1.96zm0 12.72a2 2 0 00-2-2h-1.96a2 2 0 00-2 2v1.96a2 2 0 002 2h1.96a2 2 0 002-2v-1.96zm14.32-12.72a2 2 0 00-2-2h-1.97a2 2 0 00-2 2v1.96a2 2 0 002 2h1.97a2 2 0 002-2v-1.96zm-24.65-7.72h32.82m-50.94 0h7.38M23.8 13.03a1.96 1.96 0 00-1.97-1.96s0 0 0 0a1.96 1.96 0 00-1.96 1.96v5.33a1.96 1.96 0 001.96 1.96s0 0 0 0a1.96 1.96 0 001.96-1.96v-5.33zm19.05 0a1.96 1.96 0 00-1.96-1.96s0 0 0 0a1.96 1.96 0 00-1.96 1.96v5.33a1.96 1.96 0 001.96 1.96s0 0 0 0a1.96 1.96 0 001.96-1.96v-5.33zm.94 50.91L61.5 46.86l-6.57-6.32L37.22 57.6l.02 6.3 6.55.03z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fill stroke",
    d: "M64.8 43.7l-6.57-6.34 4.3-4.14 6.58 6.32-4.3 4.15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSchedule);
export default __webpack_public_path__ + "static/media/edit-schedule.95e1dbf591f321fe7deedab5e584c537.svg";
export { ForwardRef as ReactComponent };